import { useCallback, useMemo } from 'react';
import { useInfiniteQuery, useQuery, useQueryClient } from 'react-query';

import {
  leerTodas,
  marcarLeida,
  marcarModalCerrado,
  obtenerPagina,
  obtenerResumen,
  registrarEvento,
} from './novedadesWamApi';

export const NOVEDADES_WAM_KEY = 'novedades-wam';
const MINUTO = 60 * 1000;

/** { no_leidas, destacada }: se pide al entrar, cada 10 min y al volver a la pestaña. */
export const useNovedadesResumen = ({ enabled = true } = {}) =>
  useQuery([NOVEDADES_WAM_KEY, 'resumen'], obtenerResumen, {
    enabled,
    staleTime: 5 * MINUTO,
    refetchInterval: 10 * MINUTO,
    refetchIntervalInBackground: false,
    refetchOnWindowFocus: true,
    retry: 1,
  });

/** Listado paginado (más nueva primero). */
export const useNovedadesLista = ({ enabled = true } = {}) =>
  useInfiniteQuery([NOVEDADES_WAM_KEY, 'lista'], ({ pageParam = 1 }) => obtenerPagina(pageParam), {
    enabled,
    staleTime: MINUTO,
    retry: 1,
    getNextPageParam: (ultima) => (ultima?.next ? ultima.page + 1 : undefined),
  });

/** Marcas de lectura. Después de cada una se refrescan el contador y el listado. */
export const useNovedadesAcciones = () => {
  const queryClient = useQueryClient();
  const refrescar = useCallback(() => queryClient.invalidateQueries(NOVEDADES_WAM_KEY), [queryClient]);

  return useMemo(() => {
    const conRefresco = (fn) => async (...args) => {
      try {
        return await fn(...args);
      } finally {
        await refrescar();
      }
    };
    return {
      marcarLeida: conRefresco(marcarLeida),
      leerTodas: conRefresco(leerTodas),
      marcarModalCerrado: conRefresco(marcarModalCerrado),
      registrarEvento: conRefresco(registrarEvento),
    };
  }, [refrescar]);
};
